import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';
import { goto } from '@wheelbox/lithejs-router';
import { SearchIcon } from '@wheelbox/lithejs-lucide';

import LanguageSwitcher from './language-switcher';
import ThemeSwitcher from './theme-switcher';
import SearchModal from './search-modal';
import HeaderSeparator from './header-separator';

import { createId, openAppModal } from '../../../utils';

import { APP_GLOBAL_SLICE, APP_MODAL_SLICE } from '../../../constants/app';

import { updateSlice, withSlice } from '../../../state';
import { GlobalSlice, ModalSlice } from '../../../state/index.model';

import BurgerMenu from './burger-menu';

import AppMenu from './app-menu/app-menu';

const AppHeader: LitheFC = ({ id = createId(), testId = 'app-header' }) => {
  const state = withSlice<GlobalSlice>(APP_GLOBAL_SLICE);

  const openSearchModalHandler = () => {
    updateSlice<ModalSlice>(APP_MODAL_SLICE, {
      title: 'Search',
      content: SearchModal({ id: 'app-search-modal' }),
    });

    openAppModal();
  };

  const element: LitheElement<'header'> = [
    'header',
    {
      id,
      'data-testid': testId,
      class: [
        'w-full h-12 px-4 md:px-0 mb-4 flex justify-between',
        state.theme === 'dark' ? 'text-[var(--color-dark-text)]' : '',
      ],
    },
    [
      'nav',
      { class: 'flex items-center w-full' },
      [
        'img',
        {
          src: '/assets/lithe-symbol.svg',
          class: 'h-6 w-auto cursor-pointer',
          onclick: () => goto('/'),
          alt: 'lithe logo',
        },
      ],
      AppMenu({ id: 'app-menu' }),
      BurgerMenu({ id: 'app-burger-menu' }),
    ],
    [
      'div',
      { class: 'hidden md:flex items-center gap-4' },
      [
        'button',
        {
          type: 'button',
          class: 'cursor-pointer',
          onclick: openSearchModalHandler,
          'aria-label': 'Search',
        },
        SearchIcon({
          classes: [
            'h-6 w-6 hover:stroke-[var(--color-primary)] transition-colors',
            state.theme === 'dark' ? 'stroke-[var(--color-dark-text)]' : '',
          ],
          size: 24,
          strokeWidth: 2,
        }),
      ],
      HeaderSeparator({}),
      ThemeSwitcher({ slice: APP_GLOBAL_SLICE }),
      HeaderSeparator({}),
      LanguageSwitcher({ languages: ['pl', 'en'] }),
    ],
  ];

  return element;
};

export default AppHeader;
